package com.eladfinish.bible.contest.appcontent

object AppLinks {
    const val ANDROID_PACKAGE_NAME = "com.eladfinish.jewishbiblecontest"
    const val PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=$ANDROID_PACKAGE_NAME"

    /**
     * [PLAY_STORE_URL] with an install referrer, so an install that starts from one of our own links is
     * attributed in Firebase / GA4 (`firstUserSource` / `firstUserMedium` / `firstUserCampaignName`)
     * instead of showing up as a plain `google-play / organic` install.
     */
    fun playStoreUrl(source: String, medium: String, campaign: String): String {
        val params = listOf("utm_source" to source, "utm_medium" to medium, "utm_campaign" to campaign)
        params.forEach { (key, value) -> require(value.matches(UTM_VALUE)) { "$key must match $UTM_VALUE: \"$value\"" } }
        // The referrer is itself a query string, so its own '=' and '&' are percent-encoded.
        return "$PLAY_STORE_URL&referrer=" + params.joinToString("%26") { (key, value) -> "$key%3D$value" }
    }

    private val UTM_VALUE = Regex("[a-z0-9_-]+")

    const val APP_STORE_URL = "https://apps.apple.com/app/id6778063844"

    /** The district-quiz site (Firebase project `moe-bible-contest`): "חידונים אמיתיים" and ראש בראש. */
    const val DISTRICT_QUIZ_SITE_URL = "https://bible-contest.web.app"

    /**
     * That site's exam page, "חידוני עבר": self-testing on the questions of past quizzes (school, district,
     * national, world and adult), with automatic answer checking. The app embeds it as "חידונים אמיתיים";
     * the content site links to it for visitors in a browser.
     */
    const val PAST_QUIZZES_URL = "$DISTRICT_QUIZ_SITE_URL/#/exam"

    /** The landing site's host (Firebase Hosting site `biblecontest-f3b7c`): the app's verified link domain. */
    const val LANDING_HOST = "biblecontest-f3b7c.web.app"

    /**
     * The short host of ראש בראש invitations (Firebase Hosting site `biblecontest`, the same pages as
     * [LANDING_HOST]): `https://biblecontest.web.app/duel/{code}`. Also a verified link domain.
     */
    const val SHORT_HOST = "biblecontest.web.app"

    /** The web app's and content site's host (Firebase Hosting site `biblecontest-app`). */
    const val WEB_APP_HOST = "biblecontest-app.web.app"

    /** The app's server (Cloud Run `bible-ai-server`): AI search, analytics, suggestions, PDF mail, admin API. */
    const val API_SERVER_URL = "https://bible-ai-server-826690753801.me-west1.run.app"

    /** The Windows desktop app's Microsoft Store page. */
    const val MICROSOFT_STORE_URL = "https://apps.microsoft.com/detail/9NNCX03BDPXR"

    /** The updates channel: every release is announced there (docs/release/telegram-announcements.md). */
    const val TELEGRAM_CHANNEL_URL = "https://t.me/JewishBibleContestApp"
    const val DEVELOPER_PAGE_URL = "https://play.google.com/store/apps/dev?id=6925672714464962353"
    const val CONTACT_EMAIL = "elfifo4@gmail.com"

    /** The canonical privacy policy (a published Google Doc), embedded by the web privacy pages. */
    const val PRIVACY_POLICY_URL =
        "https://docs.google.com/document/d/e/2PACX-1vS3rJ69UYP16eOu9lJr4zLQtUos8EH878UNsPIWhv4dWxxTGmBTDFFkAGt5NGUz9IdwFhtHB3uoTFGc/pub"
}
